export default "__VITE_ASSET__QdqZB99x__"